import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Philosophy from "../components/Philosophy";
import Achievements from "../components/Achievements";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import Certifications from "../components/Certifications";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import apiService from "../services/api";

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [data, setData] = useState({
    profile: null,
    skills: [],
    achievements: [],
    experience: [],
    projects: [],
    certifications: [],
    education: [],
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profile, skills, achievements, experience, projects, certifications, education] = await Promise.all([
          apiService.getProfile(),
          apiService.getSkills(),
          apiService.getAchievements(),
          apiService.getExperience(),
          apiService.getProjects(),
          apiService.getCertifications(),
          apiService.getEducation()
        ]);
        setData({ profile, skills, achievements, experience, projects, certifications, education, loading: false, error: null });
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
        setData((prev) => ({ ...prev, loading: false, error: "Failed to load portfolio data" }));
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "philosophy", "numbers", "journey", "casefiles", "arsenal", "credentials", "contact"];
      const scrollPosition = window.scrollY + 120;
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element && scrollPosition >= element.offsetTop && scrollPosition < element.offsetTop + element.offsetHeight) {
          setActiveSection(section);
          break;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (data.loading) {
    return (
      <div className="loading-container" data-testid="loading-screen">
        <div className="loading-spinner"></div>
        <p>Establishing secure connection...</p>
      </div>
    );
  }

  if (data.error) {
    return (
      <div className="error-container" data-testid="error-screen">
        <p>{data.error}</p>
      </div>
    );
  }

  return (
    <div className="portfolio-container bg-[#050505]" data-testid="portfolio-page">
      <Header activeSection={activeSection} />
      <main>
        <Hero profile={data.profile} />
        <Philosophy profile={data.profile} />
        <Achievements achievements={data.achievements} />
        <Experience experience={data.experience} />
        <Projects projects={data.projects} />
        <Skills skills={data.skills} />
        <Certifications certifications={data.certifications} education={data.education} />
        <Contact profile={data.profile} />
      </main>
      <Footer profile={data.profile} />
    </div>
  );
};

export default Portfolio;
